import Ext from 'Ext'
import LeaveRatesEditorComponent from './LeaveRatesEditorComponent'

const LeaveRatesEditorItem = function(config)
{
    LeaveRatesEditorItem.superclass.constructor.call(this, new LeaveRatesEditorComponent(config), config);
    this.editor = this.component;
    this.editor.on("render", function(editor){
        editor.getEl().swallowEvent("click");
    });
}

Ext.extend( LeaveRatesEditorItem, Ext.menu.Adapter, {
})

export default LeaveRatesEditorItem



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ratesEditor/LeaveRatesEditorItem.js